import { retryLazyImport } from '@/helpers/retry-lazy-import.js';
import companyService from '@satellite/services/company-service';
import { useStore } from 'vuex';
import i18n from '@/plugins/i18n.js';
import { loginBeforeEnter, readManageAppointmentFromQuery } from './login-route.helpers.js';

const RegistrationPage = retryLazyImport(() => import('@/modules/auth/RegistrationPage.vue'));
const LoginPage = retryLazyImport(() => import('@/modules/auth/LoginPage.vue'));
const CompanySelectPage = retryLazyImport(() => import('@/modules/auth/CompanySelectPage.vue'));

export default [
  {
    path: '/register',
    name: 'register',
    component: RegistrationPage,
    meta: {
      requiresAuth: false,
      title: () => i18n.global.t('routes.pageTitles.registration'),
      hideSidebar: true
    }
  },
  {
    path: '/login/:verificationToken?',
    name: 'login',
    component: LoginPage,
    props: route => {
      const { isManageAppointmentLogin, postLoginRoute } = readManageAppointmentFromQuery(
        route.query
      );
      return {
        verificationToken: route.params.verificationToken,
        isManageAppointmentLogin,
        postLoginRoute: postLoginRoute ?? undefined
      };
    },
    beforeEnter: loginBeforeEnter,
    meta: {
      requiresAuth: false,
      title: () => i18n.global.t('routes.pageTitles.login'),
      hideSidebar: true
    }
  },
  {
    path: '/register/company',
    name: 'register.company',
    component: CompanySelectPage,
    props: { isRegistrationStep: true },
    meta: {
      requiresAuth: true,
      title: () => i18n.global.t('routes.pageTitles.selectCompany'),
      hideSidebar: false,
      disableSidebar: true
    },
    beforeEnter: async (to, from, next) => {
      const store = useStore();

      if (from?.name !== 'login') {
        const me = store.getters['Auth/me'];
        const previewCompany = await companyService.getPreviewCompany();
        if (me?.companyId && me?.companyId !== previewCompany.id) {
          next({ path: '/book' });
          return;
        }
      }

      next();
    }
  },
  {
    path: '/auth/verify/:verificationToken',
    name: 'auth.verifyEmail',
    redirect: to => {
      const { verificationToken } = to.params;
      return { name: 'login', params: { verificationToken } };
    },
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/auth/reset-password/:resetEmail/:resetToken',
    name: 'auth.resetPassword',
    props: true,
    component: LoginPage,
    meta: {
      title: () => i18n.global.t('routes.pageTitles.resetPassword'),
      requiresAuth: false,
      hideSidebar: true
    }
  }
];
